<template>
  <div class="row member-card">
    <div class="memberSearch-wrap">
      <form @submit.prevent="setFilters">
        <div class="form-group row">
          <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
            <label>Invoice ID</label>
            <input
              v-model="filters.invoice_id"
              type="text"
              class="memberSearch-field"
              placeholder="Enter Invoice ID"
            />
          </div>

          <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
            <label>Service Start Date</label>
            <div class="effective_date">
              <date-picker
                input-class="memberSearch-field"
                placeholder="Select Start Date"
                type="date"
                v-model="filters.service_start_date"
                value-type="format"
              ></date-picker>
            </div>
          </div>

          <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
            <label>Service End Date</label>
            <div class="effective_date">
              <date-picker
                input-class="memberSearch-field"
                placeholder="Select End Date"
                type="date"
                v-model="filters.service_end_date"
                value-type="format"
              ></date-picker>
            </div>
          </div>
        </div>

        <!-- Submit Button Section -->
        <div class="row justify-content-md-end">
          <div class="col-xxl-2 col-xl-3 claim-btn-container">
            <button type="submit" class="univ-btn">Search</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  methods: {
    setFilters() {
      this.$emit("onSearch", this.filters);
    },
  },
};
</script>

<style scoped>
/* Styling for the date picker */
.effective_date .mx-datepicker {
  width: 100% !important;
}

/* Styling for the form field */
.memberSearch-field {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* Container styling for the submit button */
.claim-btn-container {
  display: flex;
  gap: 20px;
  width: 20%;
}

/* Button styling */
.univ-btn {
  background: #0cf;
  color: #fff;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.univ-btn:hover {
  background: #1597b8;
}

/* Styling for form group */
.form-group {
  margin-bottom: 20px;
}

/* Responsiveness */
@media (max-width: 768px) {
  .claim-btn-container {
    width: 100%;
    justify-content: center;
  }

  .univ-btn {
    width: 100%;
  }
}
</style>